import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { EmptyTicket } from "./EmptyTicket";
import { IDepartmentDropdown, ITicketSubjectDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";
import { ITicketMast } from "../../models/TicketMast";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { TicketStatus } from "../../models/FDropdown";

const schema = yup.object({
    department: yup.number().min(1, "Department is required*").required("Department is required*"),
    ticket_Subject: yup.string().required("Ticket_Subject is required*"),
    issue: yup.string().required("Issue is required*"),
    ticket_Status: yup.string().required("Ticket Status is required*"),
    issue_Screen: yup.string().nullable()
});

interface Iprops {
    singleData: ITicketMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [loadning, setLoading] = useState(false);
    const [department, setDepartment] = useState<Array<IDepartmentDropdown>>();
    const [ticketSub, setTicketSub] = useState<Array<ITicketSubjectDropdown>>();
    const [ticketSubDrop, setTicketSubDrop] = useState<Array<ITicketSubjectDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<ITicketMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.department && department && ticketSub) {
            const selectedDepartment = department.find(dep => dep.department_ID === props.singleData.department);
            if (selectedDepartment) {
                const t_sub = ticketSub.filter(tsub => tsub.department_ID === selectedDepartment.department_ID);
                setTicketSubDrop(t_sub);
            } else setTicketSubDrop(undefined);
        }
    }, [props.singleData]);

    const loadDepartment = async () => {
        const response = await Fetch("Dropdown/department", "GET", null, null, null);
        if (response) {
            const data: Array<IDepartmentDropdown> = await response.json();
            setDepartment(data);
        }
    }
    const loadTicketSub = async () => {
        const response = await Fetch("Dropdown/ticketSubject", "GET", null, null, null);
        if (response) {
            const data: Array<ITicketSubjectDropdown> = await response.json();
            setTicketSub(data);
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (department && ticketSub && name === "department") {
                if (value.department) {
                    const selectedDepartment = department.find(dep => dep.department_ID === value.department);
                    if (selectedDepartment) {
                        const t_sub = ticketSub.filter(tsub => tsub.department_ID === selectedDepartment.department_ID);
                        setTicketSubDrop(t_sub);
                    } else setTicketSubDrop(undefined);
                }
                else setTicketSubDrop(undefined);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, department, ticketSub]);

    useEffect(() => {
        loadDepartment();
        loadTicketSub();
    }, []);

    const saveToDB = async (body: ITicketMast) => {
        setLoading(true);
        const method = props.singleData.ticket_ID ? "PUT" : "POST";
        const message = props.singleData.ticket_ID ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("Ticket", method, body, null, props.toast);

        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyTicket);
    }

    const fileUploade = (event: FileUploadHandlerParam) => {
        // console.log(event.files[0].type);
        // if (event.files[0].type.includes("image/")) {
        if (event.files[0].size > 1024000) {
            // console.log(event.files[0].size);
            props.toast.current.show({ severity: 'error', content: "File should be less than 1 MB." });
            event.options.clear();
        } else {
            uploadeFile(event.files[0]);
        }
        // } else {
        //     props.toast.current.show({ severity: 'error', content: "Please Choose A Image." });
        //     event.options.clear();
        // }
    }

    const uploadeFile = async (file: File) => {
        setLoading(true);
        let formData = new FormData();
        formData.append("file", file);

        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}Ticket/file`, params);
        if (response) {
            const data = await response.text();
            setValue("issue_Screen", data);
            props.toast.current.show({ severity: 'success', content: `File Uploaded Successfully as -"${data}"` });
        }
        setLoading(false);
    }

    function onSubmit(data: ITicketMast) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Ticket" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVDropdown disabled={props.singleData.ticket_ID ? true : false} required label="Department" control={control} name="department" options={department} optionLabel="department_Name" optionValue="department_ID" placeholder="Select Department" error={errors.department?.message} />
                <JVDropdown disabled={props.singleData.ticket_ID ? true : false} required label="Ticket Subject" control={control} name="ticket_Subject" options={ticketSubDrop} optionLabel="ticket_Sub" optionValue="ticket_Sub" placeholder="Select Ticket Subject" error={errors.ticket_Subject?.message} />
                <JVInput disabled={props.singleData.ticket_ID ? true : false} column={1.5} required label="Issue" control={control} name="issue" error={errors.issue?.message} />
                <JVDropdown disabled={props.singleData.ticket_ID ? false : true} column={4} required label="Ticket Status" control={control} name="ticket_Status" options={TicketStatus} optionLabel="name" optionValue="name" placeholder="Select Ticket Status" error={errors.ticket_Status?.message} />
                {!props.singleData.ticket_ID && <div className="field col-12 md:col-4">
                    <FileUpload chooseLabel="Choose File" mode="basic" name="file" accept="*" maxFileSize={10000000} customUpload uploadHandler={fileUploade} />
                </div>}
                <div className="col-12 md:col-12">
                    <Button loading={loadning} className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}
